/**
 * 金额格式化（分 → 元）
 */
export function formatYuan(fen: number): string {
  return `¥${(fen / 100).toFixed(2)}`;
}

/**
 * 日期时间格式化
 *
 * 兼容 ISO 字符串、Date 对象、时间戳，输出统一的 `YYYY-MM-DD HH:mm:ss`
 * 无效输入返回 `-`，无法解析时返回原始字符串
 */
export function formatDateTime(value?: string | number | Date | null): string {
  if (value == null || value === '') return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/** 会员信息统一显示:昵称（ID）,无昵称回退 ID */
export function memberLabel(nickname?: string | null, id?: string | number | null): string {
  const name = (nickname ?? '').toString().trim();
  if (name && id != null && id !== '') return `${name}（${id}）`;
  if (name) return name;
  return id != null && id !== '' ? `ID: ${id}` : '—';
}

/**
 * 日期格式化（仅日期部分）
 */
export function formatDate(value?: string | number | Date | null): string {
  if (value == null || value === '') return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
